import { z } from 'zod';
import { Product } from './product';
import {
  validateCoproductionEmail,
  validateCoproductionPixKey,
} from '@api/coproduction';
import { ExternalValidationFunction } from '@interfaces/externalValidationResolver';

export const coproductionSchema = z.object({
  id: z.number(),
  botConfigId: z.number(),
  email: z
    .string()
    .trim()
    .nonempty('O email é obrigatório')
    .email({ message: 'O formato do email é invalido' }),
  commissionRate: z.coerce
    .number()
    .min(1, 'A taxa deve ser no mínimo 1.')
    .max(100, 'A taxa deve ser no máximo 100.')
    .transform((val) => val / 100),
  pix: z.string().trim().nonempty('A chave pix é obrigatória'),
});
export type Coproduction = z.infer<typeof coproductionSchema> & {
  isOwner: boolean;
};

export const createCoproductionSchema = coproductionSchema.omit({ id: true });
export type CreateCoproductionSchema = z.infer<typeof createCoproductionSchema>;

export const updateCoproductionSchema = createCoproductionSchema
  .pick({
    commissionRate: true,
    pix: true,
  })
  .partial();
export type UpdateCoproductionSchema = z.infer<typeof updateCoproductionSchema>;

export type CoproductionFilters = { botConfigIds: Product['id'][] };
export type ValidateEmailCredentials = Pick<
  CreateCoproductionSchema,
  'email' | 'botConfigId'
>;

export type validateCoproductionEmailDto = Pick<
  CreateCoproductionSchema,
  'email'
>;

export type ValidateCoproductionEmailResponse = {
  success: boolean;
  userId?: number;
};
export const isCoproductionEmailValid =
  (productId: Product['id']): ExternalValidationFunction =>
  async (email) => {
    const { success } = await validateCoproductionEmail(productId, {
      email: email as string,
    });

    return {
      success,
      errorMessage: 'Este usuário não é elegível para co-produção.',
    };
  };

export type validateCoproductionPikKeyDto = {
  pix: string;
};
export type ValidateCoproductionPixKeyResponse = {
  success: boolean;
  msg: string;
};

export const isCoproductionPixKeyValid =
  (productId: Product['id']): ExternalValidationFunction =>
  async (pix) => {
    const { success, msg: errorMessage } = await validateCoproductionPixKey(
      productId,
      {
        pix: pix as string,
      },
    );
    return { success, errorMessage };
  };
